import { postJson } from '../utils/fetch';
import asDataProvider from './as-data-provider';
import { Permissions } from '../../types';
import { withCached } from '../utils/with-cached';
import withHandleOptionalCloudId from './with-handle-optional-cloud-id';
import { ExperienceMark } from '../utils/experience-tracker';

// Permissions api

var fetchPermission = withCached(function (_ref) {
  var cloudId = _ref.cloudId,
    permissionId = _ref.permissionId;
  return postJson("/gateway/api/permissions/permitted", {
    permissionId: permissionId,
    resourceId: "ari:cloud:platform::site/".concat(cloudId)
  }).then(function (permission) {
    return permission.permitted;
  });
});
export var UserPermissionProvider = withHandleOptionalCloudId(asDataProvider('permission', ExperienceMark.API_PERMISSIONS, fetchPermission, fetchPermission.cached), false);
export var prefetchPermission = function prefetchPermission(_ref2) {
  var cloudId = _ref2.cloudId;
  fetchPermission({
    cloudId: cloudId,
    permissionId: Permissions.MANAGE
  });
};
export var resetPermission = function resetPermission() {
  return fetchPermission.reset();
};